<template>
  <div id="app">
    <!-- 导航栏 -->
    <header-nav></header-nav>
    <router-view />
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import Navi from "./components/Navi/Navi.vue";
import Bottom from "./components/Bottom/Bottom.vue";
export default {
  name: "App",
  components: {
    "header-nav": Navi,
    "bottom-nav": Bottom
  }
};
</script>

<style type="text/css">
html,
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  padding: 0;
  margin: 0;
  list-style: none;
  font-style: normal;
  text-decoration: none;
  border: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  user-select: none;
}
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  -webkit-text-size-adjust: none;
}
body {
  overflow-x: hidden;
}
#app {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
.el-header {
  padding: 0;
  height: 100px;
}
.page-banner {
  width: 100%;
}
.page-content {
  width: 1200px;
  margin: 100px auto;
}
.page-content p {
  font-size: 14px;
  text-align: left;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue